
export const HEADERS = {
    IF_MODIFIED_SINCE: "If-modified-since"
    // IF_MODIFIED_SINCE: "HTTP_IF_MODIFIED_SINCE"
};



// WEBPACK FOOTER //
// ./src/core/services/api/enums.ts